import React from "react";

const Copyright = () => {
  return (
    <div className="copyright">
      <p>© {new Date().getFullYear()} Resham Gurung</p>
    </div>
  );
};

export default Copyright;
